import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Clock, Users, Target } from "lucide-react";
import SectionHeader from "@/components/shared/SectionHeader";
import { PROGRAMMES } from "@/lib/data";
import { EISG } from "@/constants/testIds";

const programmeTestId = (id) => {
  if (id === "phare") return EISG.programmeCardPhare;
  if (id === "command") return EISG.programmeCardCommand;
  return EISG.programmeCardAugmentees;
};

const EISGProgrammes = () => (
  <div>
    <section className="py-28 lg:py-36 bg-[#FAFAFA] border-b border-[#0A192F]/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          number="— Programmes 2026 / 2027"
          eyebrow="Trois moments stratégiques"
          title="Pilotage. Commandement. Métiers augmentés."
          subtitle="Trois moments stratégiques pour chaque niveau de décision et d'exécution institutionnelle."
          body="Un calendrier exécutif pensé pour les CEOs, conseils d'administration, hauts cadres et décideurs publics africains."
          titleFont="eisg"
        />
      </div>
    </section>

    {PROGRAMMES.map((p, idx) => (
      <section
        key={p.id}
        data-testid={programmeTestId(p.id)}
        className={`py-24 lg:py-32 ${idx % 2 === 0 ? "bg-white" : "bg-[#FAFAFA]"}`}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className={`grid lg:grid-cols-12 gap-12 items-start ${idx % 2 === 1 ? "lg:[&>:first-child]:order-2" : ""}`}>
            <div className="lg:col-span-5">
              <div className="relative">
                <img src={p.image} alt={p.title} className="w-full h-[480px] object-cover" />
                <div className="absolute top-6 left-6 bg-[#0A192F] text-white px-4 py-2 text-xs tracking-[0.25em] uppercase font-semibold">
                  {p.location}
                </div>
                <div className="absolute -bottom-6 -right-6 bg-[#D4AF37] text-[#0A192F] px-6 py-4 font-eisg text-5xl font-bold leading-none">
                  {p.number}
                </div>
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="overline text-[#F58220]">{p.short}</div>
              <h2 className="font-eisg text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] tracking-tight leading-tight mt-4">
                {p.title}
              </h2>
              <div className="mt-6 flex flex-wrap gap-6 text-sm text-[#0A192F]/70">
                <div className="flex items-center gap-2"><MapPin size={14} className="text-[#D4AF37]" /> {p.location}</div>
                <div className="flex items-center gap-2"><Clock size={14} className="text-[#D4AF37]" /> {p.duration}</div>
                <div className="flex items-center gap-2"><Target size={14} className="text-[#D4AF37]" /> {p.cohort}</div>
              </div>
              <p className="mt-6 text-[#0A192F]/80 text-lg leading-relaxed">{p.description}</p>

              <div className="mt-10 grid md:grid-cols-2 gap-8">
                <div>
                  <div className="overline text-[#0A192F]/60 mb-4">Résultats clés</div>
                  <ul className="space-y-2.5">
                    {p.outcomes.map((o) => (
                      <li key={o} className="flex items-start gap-2 text-[#0A192F]/80 text-sm">
                        <span className="w-1 h-1 rounded-full bg-[#D4AF37] mt-2 flex-shrink-0" />
                        <span>{o}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <div className="overline text-[#0A192F]/60 mb-4">{p.parcours ? "Les 9 parcours métiers" : "Audience"}</div>
                  <ul className="space-y-2.5">
                    {(p.parcours || p.audience).map((a) => (
                      <li key={a} className="flex items-start gap-2 text-[#0A192F]/80 text-sm">
                        <Users size={12} className="mt-1 text-[#D4AF37] flex-shrink-0" />
                        <span>{a}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="mt-10 flex flex-wrap items-center gap-6 border-t border-[#0A192F]/10 pt-8">
                <div>
                  <div className="text-[11px] text-[#0A192F]/60 uppercase tracking-wider">Investissement</div>
                  <div className="font-eisg text-3xl text-[#0A192F]">{p.price}</div>
                  <div className="text-xs text-[#0A192F]/60">{p.priceUnit}</div>
                </div>
                <Link to="/eisg/registration" className="btn-premium btn-premium-primary">
                  {p.cta} <ArrowRight size={16} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    ))}
  </div>
);

export default EISGProgrammes;
